import React from "react";

import * as Sentry from "@sentry/react";

import {
  PanelContentInnerContainer,
  PanelContentOuterContainer,
  PanelMainContent,
} from "@app/analytics/account/Billing/checkout/styles";
import useBillingCustomer from "@app/analytics/account/Billing/hooks/useBillingCustomer";
import usePaymentMethod from "@app/analytics/account/Billing/hooks/usePaymentMethod";
import LINKS from "@app/common/links";

import Alert from "@rui/Alert";
import Button from "@rui/Button";
import Link from "@rui/Link";

const ExternalPaymentNeeded = () => {
  const { billingCustomer } = useBillingCustomer();
  const { createPaymentPortalLink } = usePaymentMethod();

  const hasAddress = Boolean(billingCustomer?.address);

  const handlePaymentRedirect = async (flow: "address" | "payment") => {
    // TODO: ENG-9727 remove once we know the extent that customers are using this alternate flow
    Sentry.captureMessage("Customer portal during checkout");
    createPaymentPortalLink.mutate(
      { returnUrl: window.location.href, flow },
      {
        onSuccess: (data) => (window.location.href = data.url),
      }
    );
  };

  return (
    <PanelContentOuterContainer variant="center">
      <PanelContentInnerContainer variant="center" spacing={2}>
        <PanelMainContent variant="center">
          {createPaymentPortalLink.isError ? (
            <Alert embedded severity="error">
              Sorry! The checkout process could not be completed due to an
              error. Please refresh this page or contact{" "}
              <Link href={LINKS.EMAIL.SUPPORT}>support@read.ai</Link>
            </Alert>
          ) : (
            <>
              <Alert embedded severity="info">
                Your browser settings require payment information to be added
                directly with our payment processor,{" "}
                <Link href="https://stripe.com" underline>
                  Stripe
                </Link>
                . Please add a payment method to continue.
              </Alert>
              <Button
                onClick={() =>
                  handlePaymentRedirect(hasAddress ? "payment" : "address")
                }
              >
                Add Payment Method
              </Button>
            </>
          )}
        </PanelMainContent>
      </PanelContentInnerContainer>
    </PanelContentOuterContainer>
  );
};

export default ExternalPaymentNeeded;
